/**
 * System Imports
*/

import { Config, ConfigInit } from '@system/Config';
import { TmiInit } from '@system/Tmi';

/**
 * Relative Imports
*/

import { PokemonInit } from './Pokemon';

/**
 * Functions
*/

/**
 * @return {Promise<void>}
 */
async function ApplicationStart(): Promise<void>
{
    await ConfigInit();
    await PokemonInit();
    await TmiInit(Config('username'), Config('oauth'), Config('channel'));
}

/**
 * Main
*/

ApplicationStart();
